import React, { Component } from 'react';
import { DragDropContext} from 'react-beautiful-dnd';
import moment from 'moment'

import './ListContainer.css'

import List from './List'

class ListContainer extends Component {

  constructor(props) {
    super(props)
    const today = moment().startOf('day') //moment().startOf('day')
    const todayDayOfWeek = today.clone().isoWeekday()
    const isMonday = todayDayOfWeek === 1
    const isTuesday = todayDayOfWeek === 2
    const isWednesday = todayDayOfWeek === 3
    const isThursday = todayDayOfWeek === 4 // Its Thursday
    const isFriday = todayDayOfWeek === 5 // Its Friday
    const isSaturday = todayDayOfWeek === 6
    const isSunday = todayDayOfWeek === 7

    const lists = []

    lists.push({
      title: "TODAY",
      start: null,
      end: today.format('YYYY-MM-DD'),
      text: `${today.format('dddd')}`,
      newItemDate: today.format('YYYY-MM-DD')
    })

    lists.push({
      title: "TOMORROW",
      start: today.clone().add(1, 'days').format('YYYY-MM-DD'),
      end: today.clone().add(1, 'days').format('YYYY-MM-DD'),
      text: today.clone().add(1, 'days').format('dddd'),
      newItemDate: today.clone().add(1, 'days').format('YYYY-MM-DD')
    })

    if (isMonday) {
      lists.push({
        title: "THIS WEEK",
        start: today.clone().isoWeekday(3).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(3).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(5).format('YYYY-MM-DD')
      })
    }

    if (isTuesday) {
      lists.push({
        title: "THIS WEEK",
        start: today.clone().isoWeekday(4).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(4).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(5).format('YYYY-MM-DD')
      })
    }

    if (isWednesday) {
      lists.push({
        title: "THIS WEEK",
        start: today.clone().isoWeekday(5).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(5).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(5).format('YYYY-MM-DD')
      })
    }

    if (isThursday || isFriday ) {
      lists.push({
        title: "NEXT WEEK",
        start: today.clone().isoWeekday(1+7).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5+7).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(1+7).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(1+7).format('YYYY-MM-DD')
      })
    }

    if (isSaturday ) {
      lists.push({
        title: "THIS WEEK",
        start: today.clone().isoWeekday(1+7).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5+7).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(1+7).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(1+7).format('YYYY-MM-DD')
      })
    }

    if ( isSunday ) {
      lists.push({
        title: "THIS WEEK",
        start: today.clone().isoWeekday(2+7).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(5+7).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(2+7).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(2+7).format('YYYY-MM-DD')
      })
    }

    // Monday to Wednesday
    if (todayDayOfWeek >= 1 && todayDayOfWeek <= 4) {
      lists.push({
        title: "THIS WEEKEND",
        start: today.clone().isoWeekday(6).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(7).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(6).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(6).format('YYYY-MM-DD')
      })
    }

    if (isFriday) {
      lists.push({
        title: "THIS WEEKEND",
        start: today.clone().isoWeekday(7).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(7).format('YYYY-MM-DD'),
        text: `${today.clone().isoWeekday(7).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(7).format('YYYY-MM-DD')
      })
    }

    if (isSaturday || isSunday) {
      lists.push({
        title: "NEXT WEEKEND",
        start: today.clone().isoWeekday(6+7).format('YYYY-MM-DD'),
        end: today.clone().isoWeekday(7+7).format('YYYY-MM-DD'),
        text: `Next ${today.clone().isoWeekday(6+7).format('dddd')}`,
        newItemDate: today.clone().isoWeekday(7+7).format('YYYY-MM-DD')
      })
    }

    lists.sort( (a, b) => a.newItemDate > b.newItemDate)
    let latestDate = moment(lists[lists.length-1].end).add(1, 'days')

    const endOfMonth = latestDate.clone().add(1, 'days').endOf('month')

    const isSameMonth = endOfMonth.clone().month() === today.clone().month()

    lists.push({
      title: isSameMonth ? "THIS MONTH" : "NEXT MONTH",
      start: latestDate.format('YYYY-MM-DD'),
      end: endOfMonth.format('YYYY-MM-DD'),
      text: `By end of month`,
      newItemDate: latestDate.format('YYYY-MM-DD')
    })

    this.state = {
      lists: lists
    }

    this.handleItemDrop = this.handleItemDrop.bind(this)
    this.getItemsArray = this.getItemsArray.bind(this)
  }

  getItemsArray(start, end) {

    const itemsArray = this.props.globalState.todos
      .filter(i => !i.isDone)
      .filter(i => i.content.toLowerCase().includes(this.props.globalState.textFilter.toLowerCase()))

    const output = start
    ? itemsArray.filter(item => item.duedate >= start && item.duedate <= end)
    : itemsArray.filter(item => item.duedate <= end)

    return output.sort( (a,b) => a.order-b.order)
  }

  handleItemDrop(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const isSameList = result.source.droppableId === result.destination.droppableId

    const startIndex = result.source.index
    const endIndex = result.destination.index

    const oldList = this.state.lists[parseInt(result.source.droppableId, 10)]
    const oldListItems = this.getItemsArray(oldList.start, oldList.end)
    const item = this.props.globalState.todos.find(item => item.id === result.draggableId)

    const newList = this.state.lists[parseInt(result.destination.droppableId, 10)]
    const newListItems = this.getItemsArray(newList.start, newList.end)
    const newDueDate = newList.end

    if (isSameList){
      const result = Array.from(oldListItems);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      this.props.actions.updateOrder(result)
    } else {
      const result = Array.from(newListItems);
      const old = Array.from(oldListItems);

      const [removed] = old.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      this.props.actions.updateOrder(result)
      this.props.actions.updateOrder(old)
      this.props.actions.updateItem(item.id, item.content, newDueDate)
    }
  }

  componentWillMount() {

    const lists = [...this.state.lists]
    lists.sort( (a, b) => a.newItemDate > b.newItemDate)
    this.setState({lists})

  }

  render() {
    return(
      <div className="listContainer">
        <DragDropContext onDragEnd={this.handleItemDrop}>
            {
              this.state.lists.map( (list,index) =>
                <List key={index}
                      id={index}
                      {...list}
                      items={this.getItemsArray(list.start, list.end)}
                      />
              )
            }
        </DragDropContext>
      </div>
    )
  }
}

export default ListContainer



// WEBPACK FOOTER //
// ./src/components/ListContainer.js